import React from 'react';
import Box from "@mui/material/Box";
import makeStyles from "@mui/styles/makeStyles";
import { Typography, Divider } from '@mui/material';

import NewTooltip from './NewTooltip';
import { CustomTooltip } from './InfoTooltip';

const useStyles = makeStyles((theme) => ({
  container: {
    background: "white",
    minWidth: 100,
    height: 'fit-content',
    display: "flex",
    position: "relative",
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: '4px',
    overflow: 'hidden'
  },
  slider: {
    position: "absolute",
    top: 0,
    bottom: 0,
    background: theme.palette.primary['clr-50'],
    zIndex: 0,
    transition: "400ms ease-in-out",
    borderRadius: '4px',
    margin: theme.spacing(1)
  },
  content: {
    flex: 1,
    padding: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "transparent",
    zIndex: 1,
    letterSpacing: 1,
    color: "#02569D",
    cursor: "pointer",
    transition: "400ms ease-in-out",
  },
  contentDisabled: {
    cursor: "not-allowed",
  },
  tooltipBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    width: '400px',
    padding: '10px',
  },
  divider: {
    alignSelf: 'stretch',
    zIndex: 1,
    borderColor : '#CCD4DE'
  }
}));

function TabSwitch({
  width,
  height,
  disabled = false,
  value = 0,
  options = [],
  tooltips = [],
  onChange = () => {},
  ...props
}) {
  const classes = useStyles();

  const handleToggle = (index) => () => {
    if (value !== index) {
      onChange(options[index], index);
    }
  };

  const optionCount = options.length;
  const sliderWidth = `${(100 / optionCount) - 2.5}%`;
  const sliderLeft = `${(100 / optionCount) * value}%`;

  return (
    <Box width={width} {...props}>
      <Box className={classes.container} style={{ height }}>
        <Box
          className={classes.slider}
          sx={{
            width: sliderWidth,
            left: sliderLeft,
          }}
        />
        {options.map((option, index) => {
          const tooltipContent = tooltips[index];

          const content = (
            <React.Fragment key={index}>
              <CustomTooltip
                placement='bottom'
                component={option?.tooltip}
                tooltipStyle={{backgroundColor: '#262B30', textAlign: 'flex-start' , cursor : 'default'}}
                arrowStyle={{color: '#262B30'}}
              >
                <Box
                  className={`${classes.content} ${disabled ? classes.contentDisabled : ''}`}
                  onClick={handleToggle(index)}
                  style={{ flex: `0 0 ${100 / optionCount}%` }}
                >
                  <Typography
                    variant="h6-medium"
                    color={value === index ? 'primary.main' : 'neutral.clr-800'}
                  >
                    {option?.label || `Option ${index + 1}`}
                  </Typography>
                </Box>
              </CustomTooltip>
              {index < options.length - 1 && (
                <Divider orientation="vertical" className={classes.divider} />
              )}
            </React.Fragment>
          );

          return tooltipContent ? (
            <NewTooltip key={index} component={tooltipContent}>
              {content}
            </NewTooltip>
          ) : (
            content
          );
        })}
      </Box>
    </Box>
  );
}

export default TabSwitch;